import React from 'react'
import SimplePage from '../layouts/simplePage'

const TermsAndCondition = () => {
    return (
        <SimplePage
            title={'TERMS & CONDITIONS'}
            image={require('../assets/images/carlous-img3.jpg')}
        >
            <div className='col-sm-9'>
                <div className='contentWrapper'>
                    <div className='content'></div>
                </div>
                <h5>
                    BOOKING &amp; PAYMENT CONDITIONS INCLUDING CANCELLATIONS AND
                    DISCLAIMBERS{' '}
                </h5>
                <h5>Package Payment</h5>
                <p>
                    Initial non-refundable Booking Deposit –&nbsp;
                    <strong>
                        Rs.5000/- per person along with enquiry or as per online
                        payment process.
                    </strong>{' '}
                    &nbsp;&nbsp;Full payment has to be paid at least
                    30&nbsp;days prior to departure. For bookings less than
                    30&nbsp;days prior to departure, full money is to be paid at
                    the time of booking.
                </p>
                <p>
                    Tickets, Hotel vouchers, Transport vouchers and Tour
                    Documents would be issued 7 days prior to date of
                    departure.&nbsp;
                </p>
                <br />
                <h5>Package Cancellations</h5>
                <ol>
                    <li>
                        45 to 30&nbsp;days prior to commencement of tour,
                        cancellation fee,10&nbsp;percent.
                    </li>
                    <li>
                        29 to 16&nbsp;days prior to commencement of tour,
                        cancellation fee,&nbsp;50 percent.
                    </li>
                    <li>
                        No refund&nbsp;for cancellation with less than&nbsp;15
                        days.
                    </li>
                </ol>
                <br />
                <h5>Hotel Payment</h5>
                <ol>
                    <li>25%&nbsp;advance to confirm a hotel.</li>
                    <li>75%&nbsp;payment 30 days in advance.</li>
                </ol>
                <br />
                <p>
                    This may change for some properties and you need to check
                    with us before booking them. Most of the wildlife lodges and
                    Spa resorts insist for 100% payment for confirmation and
                    also during peak period.
                </p>
                <br />
                <h5>Hotel Cancellations</h5>
                <h6>
                    Prior to commencement of tour and counted from a working
                    day.
                </h6>
                <ol>
                    <li>
                        45 to 30&nbsp;days check in period, cancellation
                        fee,&nbsp;25 percent.
                    </li>
                    <li>
                        29 to 16&nbsp;days check in period, cancellation
                        fee,&nbsp;50 percent.
                    </li>
                    <li>
                        No refund&nbsp;for cancellation with less than 15 days.
                    </li>
                </ol>
                <br />
                <h5>Jungle Lodges Booking Process including cancellations</h5>
                <h5>Reservation Policy</h5>
                <p>
                    Booking will be confirmed only on receipt of full payment.
                    Booking made without payment will be held purely on
                    tentative basis only. We may sell the same to other guest
                    (s) without notice. We request you to keep track of the
                    status of tentative bookings.{' '}
                </p>
                <h5>Cancellation Policy</h5>
                <p>
                    All requests for cancellations of confirmed booking have to
                    be received in by email to our office.
                </p>
                <ol>
                    <li>
                        45 to 30&nbsp;days check in period, cancellation
                        fee,&nbsp;25 percent.
                    </li>
                    <li>
                        29 to 16&nbsp;days check in period, cancellation
                        fee,&nbsp;50 percent.
                    </li>
                    <li>
                        No refund&nbsp;for cancellation with less than 15 days.
                    </li>
                </ol>
                <br />
                <h5>Transport Payment</h5>
                <ol>
                    <li>
                        20%&nbsp;advance to confirmation transport service
                        initially.
                    </li>
                    <li>60%&nbsp;payment 30 days in advance.</li>
                    <li>20%&nbsp;on or before commencement of tour.&nbsp;</li>
                </ol>
                <br />
                <h5>Transport Cancellations</h5>
                <h6>
                    Prior to commencement of tour and counted from a working
                    day.
                </h6>
                <ol>
                    <li>
                        45 to 30&nbsp;days prior to commencement of tour,
                        cancellation fee,&nbsp;10 percent.
                    </li>
                    <li>
                        29 to 16&nbsp;days prior to commencement of tour,
                        cancellation fee,&nbsp;25 percent.
                    </li>
                    <li>
                        No refund&nbsp;for cancellation with less
                        than&nbsp;2&nbsp;days.
                    </li>
                </ol>
                <br />
                <p>
                    Payments by online using our secured Net Banking /Payment
                    Gateway / RTGS/NEFT/ Demand drafts to be payable in the name
                    of “ Skyway International Travels” . On payment of the
                    deposit amount you will be given an official receipt from
                    Skyway.
                </p>
                <br />
                <h5>AMENDMENTS / CANCELLATIONS</h5>
                <p>
                    If the Client is willing to amend or cancel his/her booking
                    because of whatsoever reasons including death, accident,
                    illness, or any other personal reasons including non-payment
                    of the balance payment, the Company is liable to recover
                    cancellation charges from the Client as above.
                </p>
                <p>
                    Any amendment in the original booking has to be given to us
                    in writing. All changes will be processed only after the
                    receipt of the same by the Company. However, if any of the
                    amendment requests results in cancellation of one or more
                    services, then the Company is liable to recover cancellation
                    charges as indicated in the above-mentioned table. The
                    above-mentioned cancellation charges are applicable only
                    against our Tours and optional tours published by Skyway. If
                    the client has booked any other services such as air / train
                    tickets or any third party product, then the Company is
                    liable to recover cancellation charges as per cancellation
                    terms of respective airline / railways / hotel or the
                    cancellation terms of respective third party. Skyway is also
                    liable to recover its service charges against booking and
                    cancelling such services for the client.
                </p>
                <br />
                <h5>REFUNDS</h5>
                <p>
                    Refunds (If any) for amendments and/or cancellations will be
                    paid directly to the Client for booking made directly with
                    the Company by way of NEFT / RTGS / Crossed cheque at the
                    discretion of the company. It would at least take 15 days to
                    process refunds. There is no refund payable for any
                    unutilized services (e.g. meals, entrance fees, optional
                    tours, hotels, transport and sightseeing etc.,) for any
                    reason whatsoever.
                </p>
                <br />
                <h5>CONDITIONS OF TRAVEL</h5>
                <ul>
                    <li>
                        The client will have to strictly follow the Tour
                        Program. There shall be no refund, if the client fails
                        to join the group at the commencement of the tour, or
                        joins the group later or leaves the group before tour
                        ending. It shall be noted that for all purposes, it
                        shall be the responsibility of the client to reach the
                        place of commencement of the tour and register with the
                        representative of the company at the appointed place,
                        date and time.
                    </li>
                    <li>
                        In case where a client along with his family is
                        compelled to discontinue the tour due to any reason
                        whatsoever including illness, death or loss of any
                        travel documents, no claim shall be entertained for
                        refund of unutilized services. Even if a client is
                        unable to reach the place of commencement of the tour
                        due to any reason whatsoever including loss of baggage
                        or loss of travel documents, his booking shall be
                        treated as "no show" on the tour and 100% cancellation
                        charges will be levied.
                    </li>
                    <li>
                        If a client avails pre - tour services or part thereof,
                        or the air tickets (if booked under any offer) but fails
                        to join the group for the main tour at the appointed
                        place, or cancels the tour after using the air tickets
                        or pre - tour arrangements or part thereof, it shall be
                        treated as "no show" and there will be no refund
                        whatsoever for the unutilized pre-tour or main tour
                        services.
                    </li>
                    <li>
                        The company reserves the right to withdraw tour
                        membership of any client whose behaviour is deemed
                        likely to affect the smooth operation of the tour or
                        adversely affect the enjoyment or safety of other
                        passengers and the Company shall be under no liability
                        to any such person.
                    </li>
                    <li>
                        The immunities provided under this contract shall be
                        available to THE COMPANY's employees, directors,
                        managers, including, Employees and Agents but not to the
                        Independent Contractors selected by the company.{' '}
                    </li>
                    <li>
                        Each of these conditions shall be severable from the
                        other and if any provision be invalid, illegal or
                        unenforceable, the remaining provisions shall
                        nevertheless have full force and effect. No liability on
                        the part of THE COMPANY arising in any way out of the
                        Contract in respect of any tour, holiday, excursion
                        facilities shall exceed the total amount paid or agreed
                        to be paid for the tour holiday, and shall in no case
                        include any consequential, incidental loss or additional
                        expense whatsoever.
                    </li>
                    <li>
                        It is a condition of Booking that the client takes out a
                        Holiday Insurance. – Client may procure travel insurance
                        (optional) at their own cost.{' '}
                    </li>
                    <li>
                        The prices quoted in our website / brochure have been
                        calculated at the rate prevailing at the time of
                        publishing / printing. THE COMPANY reserves the right to
                        amend the prices published in this brochure in case of
                        fuel costs, special/high season charge levied by the
                        suppliers, hike in the airline/rail charges before the
                        date of departure and to surcharge accordingly. The
                        Client must pay for all such increases in price in full
                        before the departure.
                    </li>
                    <li>
                        If no suit/action is brought against THE COMPANY within
                        7 days of the last day of the tour, THE COMPANY shall be
                        discharged from all liabilities under/or arising out of
                        this contract and the client shall be deemed to have
                        relinquished/abandoned all his rights under or arising
                        from this contract.
                    </li>
                    <li>
                        In case of publication of any travel scheme offering any
                        discount or benefit by THE COMPANY, we shall have the
                        sole right to withdraw such a scheme or discount at any
                        time unless a specific assurance of the contrary is
                        published.
                    </li>
                </ul>
                <br />
                <h5>LIABILITY </h5>
                <ul>
                    <li>
                        In the event of THE COMPANY exercising its rights to
                        amend or alter any tour or holiday advertised in their
                        brochure/ itinerary after such tour or holiday has been
                        booked, the Client shall have the right:
                    </li>
                    <ul>
                        <li>
                            To continue with the Tour or holiday as amended or
                            altered or to accept any alternative tour or
                            holiday, which the company may offer.
                        </li>
                        <li>
                            In either of these above cases the client shall
                            neither be entitled to nor THE COMPANY be liable to
                            the client for any damage, additional expenses,
                            consequential loss suffered by him or to pay any
                            amount as refund. In the event that the company is
                            unable to conduct a particular tour, the company
                            shall at its own discretion, refund the amount of
                            the cost of the said tour to the client (after
                            deducting the actual expenses incurred by the
                            company on clients' booking and on other overheads
                            as applicable from case to case) without any
                            interest on the same. The client will not be
                            entitled to make any grievance thereafter in respect
                            of the same.
                        </li>
                    </ul>
                    <li>
                        The company shall, in no circumstances whatsoever be
                        liable to the client or any person traveling with him
                        for:
                    </li>
                    <ul>
                        <li>
                            any death, personal injury, sickness, accident,
                            loss, delay, discomfort, increased expenses,
                            consequential loss and/or damage or any kind of
                            theft howsoever caused.
                        </li>
                        <li>
                            Any act, omission, default of any independent
                            contractor or other person or by any servant or
                            agent employed by them who may be engaged or
                            concerned in the provision of accommodation,
                            refreshment, carriage facility or service for the
                            client or for any person traveling with him
                            howsoever caused.
                        </li>
                        <li>
                            The temporary or permanent loss of or damage to
                            baggage or personal effects howsoever caused
                            including wilful negligence on the part of any
                            person.
                        </li>
                        <li>
                            Loss of baggage by the airlines / coach / train.
                        </li>
                        <li>Overbooking of seats by the airline.</li>
                        <li>
                            Failure on the part of airline to accommodate
                            passengers despite having confirmed tickets or
                            change of route.
                        </li>
                    </ul>
                    <li>
                        If in the event that the client is booked on a
                        particular airline and the said flight is over
                        booked/cancelled for whatever reason and the client is
                        not allowed/able to board the flight, the client shall
                        not hold the company responsible for the same and no
                        claim whatsoever can be made by the client against the
                        company for refund or compensation.
                    </li>
                    <li>
                        The company shall not be responsible and / or liable for
                        any damages caused to the client due to reasons beyond
                        the control of the company (Force Majeure / Vis
                        Majeure). While enjoying the services provided by us, if
                        any client’s acts or omission results in damage or loss
                        to us / vendor or service provider which includes but is
                        not limited to (airlines, hotels, transports etc. and
                        vendors’ staff), the client shall be liable and agrees
                        to indemnify and hold harmless the company its
                        directors, managers / officers or such vendor from and
                        against such claims.
                    </li>
                </ul>
                <br />
                <h5>SCOPE OF ACTIVITY</h5>
                <p>
                    We are Tours &amp; Travel organizers only. We do not control
                    or operate any airline, neither do we own or control any
                    shipping company, coach or coach company, Hotel, Transport
                    or any other facility or service mentioned in this
                    brochure/website. We take care in selecting all the
                    ingredients in your holiday, but because we only select and
                    inspect them and have no control in running of them, we
                    cannot be responsible for mechanical fault or any injury,
                    death, loss or damage which is caused by the act or default
                    of the management or employees of any hoteliers, airlines,
                    shipping company, coach owner/ Transport operator who are
                    the company’s independent contractors arising outside our
                    normal selection and inspection process.
                </p>
                <br />
                <h5>DEFINITION:</h5>
                <ul>
                    <li>
                        Client/guest means the Person / Persons in whose name or
                        on whose behalf the booking is made.
                    </li>
                    <li>Company means Skyway International Travels. </li>
                    <li>
                        Tour cost/price means the amount mentioned in the Tour
                        Cost/Price column in the brochure / website.{' '}
                    </li>
                    <li>
                        Independent Contractors means “Hotelier / Hotel owner ,
                        Owner of any airlines or shipping company or Railway,
                        Ferry boat owner/Operator/ Coach owner / Operator, or
                        any other person or organization who have been selected
                        by the company to render services to the client.
                    </li>
                    <li>
                        Tour arrangement means a tour operated by the Company
                        which is operated by the Company within India or abroad
                        and includes but not limited to brochure tours, special
                        tours, packages, cruise, sightseeing etc.
                    </li>
                    <li>
                        Brochure means catalogue / leaflet / website / email or
                        any other document containing the details about the
                        itinerary / activities on the tour/packages.{' '}
                    </li>
                    <li>
                        Infant means a person below the age of 2 years and a
                        child means a person above the age of two and below the
                        age of Twelve years.
                    </li>
                </ul>
                <br />
                <h5>TERMS &amp; CONDITIONS:</h5>
                <ul>
                    <li>
                        There is no contract between the company and the client
                        until the company has received the initial deposit
                        amount per person as specified for each tour package.
                        The full payment must be received in accordance with
                        procedures laid down under Payments Terms. If not paid
                        in that time, the company reserves the right to cancel
                        the booking with consequent loss of deposit and apply
                        scale of cancellation charges as mentioned in the
                        cancellation policy hereunder.
                    </li>
                    <li>
                        The Company has the right at any time and for any
                        reason:
                    </li>
                    a) To terminate the contract after acceptance of the deposit
                    but prior to the commencement of tour without assigning any
                    reason whatsoever. In the event, the Company terminates the
                    contract, the company shall refund the initial deposit
                    amount without payment of any interest.
                    <br />
                    b) To amend, alter, vary or withdraw any tour, holiday,
                    excursion or facility it has advertised or published or to
                    substitute an Independent Contractor of similar class if it
                    is deemed advisable or necessary. In either case, the
                    Company shall not be liable for any damage, additional
                    expense, or consequential loss suffered by the Clients or
                    for any compensation claims made.
                    <br />
                    c) The Company would be operating its Group Tours with
                    minimum group strength of 16 adult passengers in each group.
                    If the group strength falls below 16 passengers, the Company
                    reserves the right to Pre-pone OR Postpone OR Merge or
                    Cancel the group. If the Company cancels the Group Tour for
                    any of the above reasons then the monies paid till then by
                    Clients will be refunded against the receipt copies. It is
                    clear understanding between either parties that any loss
                    arising on account of cancellation of flight / train / bus
                    tickets booked by the Clients; either through the Company or
                    on his/her own or through a third party; the Company shall
                    not be liable for such losses or additional expense, or
                    consequential loss suffered by the Clients.
                    <br />
                    <li>
                        No person other than the Company, in writing, has the
                        authority to vary, add, amplify or waive any
                        stipulation, representation, term or condition in this
                        brochure.
                    </li>
                    <li>
                        In the event of the Company exercising its rights to
                        amend or alter any of the services as mentioned in the
                        itinerary, after such tour or holiday has been booked,
                        the Client shall have the right: a) To continue with the
                        tour or holiday as amended or altered.
                        <br />
                        b) To accept any alternative tour or holiday which the
                        company may offer. In either of these above cases the
                        Client shall not be entitled to, or the Company shall
                        not be liable to the Client for any damage. Additional
                        expense, consequential loss suffered by him or to pay
                        any amount as refund.
                    </li>
                    <li>
                        In case of any dispute, decision of Skyway International
                        Travels will be final and binding.
                    </li>
                    <li>
                        Skyway reserves the right to call you back on the
                        contact number shared by you on the website.
                    </li>
                    <li>
                        Health &amp; Safety: The Company shall in no
                        circumstances whatsoever will be liable to the Client or
                        any person traveling for:
                    </li>
                    a) Any death personal injury, sickness, accident, loss,
                    delay, discomfort, increased expenses, consequential loss
                    and / or damage or any misadventure howsoever caused
                    <br />
                    b) Any act, omission, default or Independent Contractor or
                    other person or be any servant or agent , employed by them
                    who may be engaged or concerned in the provision of
                    accommodation, refreshment, carriage facilities or service
                    for the Client or for any person travelling with him
                    howsoever caused.
                    <br />
                    c) The temporary or permanent loss of or damage to baggage
                    or personal effects howsoever caused In this condition the
                    expression “Howsoever caused” includes negligence on the
                    part of any person.
                    <br />
                    <li>
                        No liability on the part of the Company arising in any
                        way out of this Contract in respect of any tour,
                        holiday, excursion facility shall exceed the total
                        amount paid or agreed to be paid for the tour holiday,
                        and shall in no case include any consequential loss or
                        additional expense whatsoever.
                    </li>
                    <li>
                        a) If the Client has any complaint in respect of the
                        services provided by any of the Independent Contractors,
                        the Client shall immediately notify the same in writing
                        to the Independent Contractor and a copy thereof should
                        be handed over to the Tour Manager of the Company in
                        order to enable the Company to take up the matter with
                        the Independent Contractor so that in future other
                        Clients do not face the same difficulty.
                        <br />
                        b) Any claim or complaint by the Client must be notified
                        to the Company in writing within 7 days of the end of
                        this holiday tour. No claim notified to this Company
                        beyond this period will be entertained and the Company
                        shall incur no liability whatsoever in respect thereof.
                        <br />
                    </li>
                    <li>
                        It is hereby declared that the immunities provided under
                        this Contract shall be available to the Company’s
                        managers, including Tour managers, employees, servants
                        and agents but not to the Independent Contractors
                        selected by the Company.
                    </li>
                    <li>
                        Each of this condition shall be severable from the other
                        end if any provision be invalid, illegal or
                        unenforceable. The remaining provisions shall
                        nevertheless have full force and effect.
                    </li>
                    <li>
                        Insurance: The tour cost does not include the any costs
                        towards the Travel / Mediclaim Insurance premium. In
                        case if the Client needs an Insurance coverage, it is
                        suggested to go for suitable insurance policy on your
                        own. The Client has to deal directly with the Insurance
                        company in case of settlement of any claim. The
                        toll-free number is available on your policy document.
                        Skyway or its subsidiary companies or agents has no role
                        to pay in this regard. Details of Insurance coverage are
                        available with our sales team.
                    </li>
                    <li>
                        Change in Tour Price: The tour prices printed /
                        advertised / quoted to Client are dynamic prices. The
                        person booking tour early is likely to get the lowest
                        price as communicated / offered by the Company, subject
                        to availability of seats. Similarly, person booking tour
                        at the last will be offered the highest prices. This
                        pricing module has been adopted to get early bookings on
                        tours. Hence it is quite obvious that persons travelling
                        on a same group tour are likely to have paid different
                        tour prices. The Company will not entertain any claim
                        whatsoever on account of the same. Also it is clear
                        agreement between either parties that the prices quoted
                        in the proposal / brochure have been calculated based
                        upon the prevailing hotel / transport tariffs and
                        applicable taxes thereon at the time of printing this
                        brochure. The Company reserves the right to amend the
                        price published in this brochure in case of costs
                        increased before the date of departure. All such
                        increases in price must be paid for in full before
                        departure by the Client.
                    </li>
                    <li>
                        {' '}
                        Force Majure:-Acts of god (including exceptional adverse
                        weather conditions), earthquake, fire , war (declared or
                        undeclared), invasion, rebellion, revolt, riot, civil
                        commotion, civil war, nuclear fission, strike, act(s) of
                        omission/commission by any concerned government(s), or
                        government agencies, judicial or quasi-judicial
                        authorities, occurrence of any event can force the
                        Company to change or extended. Hence any additional
                        expenditure occurred due to the above reasons the same
                        will be borne by the passengers.
                    </li>
                </ul>
                <br />
                <h5>ITINERARY CHANGES</h5>
                <p>
                    For the comfort and convenience of our passengers, we will
                    sometimes reverse the direction, or slightly amend the
                    itinerary. We will try to advise you of these amendments,
                    prior to the start of the tour or on tour. In the event that
                    a tour participant misses on any part of the sightseeing
                    tour or any such tour due to delay on his part, he will not
                    be entitled to claim refund of the same.
                </p>
                <br />
                <h5>HOTEL</h5>
                <p>
                    We have mentioned the indicative names of the Hotels for
                    each tour. We reserve the right to change the same due to
                    unavoidable circumstances. In that case we may provide
                    alternative, similar accommodation for which we are not
                    liable to pay any refund. We will not be responsible or
                    liable in case of loss of property or life at the Hotel.
                    Similarly any damages caused to the hotel rooms during your
                    stay, shall be payable by the Clients and the Company will
                    not be liable for the same.
                </p>
                <br />
                <h5>Taxi Booking</h5>
                <ul>
                    <li>
                        Our chauffeur always hold placard and stand at main
                        entrance of arrival. You need to come and identify him
                        if you come out of any other entrance.
                    </li>
                    <li>
                        We normally SMS previous day evening between 18.00 to
                        19.30hrs with chauffeur name, cell number and vehicle
                        number. Please call +91-821-244 4444,
                        +91-9845199077/9845125511 - 24/7 - to reconfirm your
                        service and for any assistance.
                    </li>
                    <li>
                        If you are unable to locate your chauffeur for any
                        reason, it is your responsibility to call the number
                        shown on your voucher or above number to assist you
                        before making alternative arrangements.
                    </li>
                    <li>
                        Please ensure that you are waiting in the main lobby of
                        your accommodation at least 5 minutes prior to your
                        confirmed pick up time if you are staying in a hotel.
                    </li>
                    <li>
                        If traveling with babies/infants, you are responsible
                        for bringing infant seat with you in your vehicle
                    </li>
                    <li>
                        Total cost is an estimate; the final price may vary
                        depending on the actual Km travelled. You still pay for
                        minimum kms even if it is not utilized.
                    </li>
                </ul>
                <br />
                <h5>AIRLINE</h5>
                <p>
                    The airfares the Company has contracted with various
                    airlines are non-refundable. The Company shall in no
                    circumstances whatsoever be liable to the Client or any
                    person travelling with him/her for:
                </p>
                <ul>
                    <li>
                        While all efforts would be made to accommodate members
                        of a family traveling together in the same flight,
                        depending upon the overall group size the company
                        reserves the right to split the group into multiple
                        airlines for any departure.
                    </li>
                    <li>
                        Loss of baggage/ loss of life or loss of other valuables
                        by the airlines.
                    </li>
                    <li>Overbooking of seats by the airline.</li>
                    <li>
                        Failure on the part of airline to accommodate passengers
                        despite having confirmed tickets.
                    </li>
                    <li>
                        Change of flight timings or change of route with or
                        without prior intimation.
                    </li>
                    <li>
                        If in the event that the flight is over booked or
                        cancelled for whatever reason and the client is not
                        allowed/able to board the flight, the client shall not
                        hold the Company responsible for the same and no claim
                        whatsoever can be made by the client. All incidental
                        expenses arising out of such situation will be payable
                        by the Client.
                    </li>
                    <li>
                        Please note the low cost airlines do not provide meals
                        on board.
                    </li>
                    <li>
                        There is a limitation how much luggage can be carried as
                        check-in baggage and cabin (hand) baggage. Luggage
                        carried over and above the limit will have to be paid
                        for by the Client at the time of check-in. Please note
                        for few sectors caring cabin baggage is not allowed.
                    </li>
                    <li>
                        Airport taxes /airport development fees as applicable to
                        be paid over &amp; above tour cost should there be a
                        rise post the printing of the brochure.
                    </li>
                    <li>
                        Though chances are less, however depending upon the
                        group size the company reserves the right to split the
                        group into multiple airlines for any departure.{' '}
                    </li>
                    <li>
                        All the airline ticket bookings / cancellation and
                        travel on such airline ticket will be subject to the
                        terms &amp; conditions as mentioned in our Booking &amp;
                        Cancellation policy mentioned in this document.
                    </li>
                </ul>
                <br />
                <h5>DISCLAIMER </h5>
                <ul>
                    <li>
                        The Client agrees and acknowledges that they consent to
                        participate in the excursion activities (trekking, jeep
                        safari, coracle ride, boat rides, ferry rides,
                        snorkelling etc. which is included in the tour) without
                        any obligation from the Company. Client confirms that
                        he/she is medically fit to participate in all activities
                        involved in excursion activities &amp; fully accept my
                        personal responsibility of my safety.
                    </li>
                    <li>
                        THE COMPANY shall not be liable for any physical injury
                        or loss of life caused to the Client due to such
                        participation.
                    </li>
                    <li>
                        Law &amp; Jurisdiction: For all complaints, suits,
                        claims or disputes of whatsoever nature relating to any
                        products including tours by the Company and third party
                        products and tours, the courts and tribunals in Mysore,
                        India alone shall have exclusive jurisdiction. All tours
                        are subject to laws, rules of RBI / Govt. of India or
                        local bodies or respective country rules and
                        regulations.{' '}
                    </li>
                </ul>
                <br />
                <p>
                    Upon signing the booking form, the above-mentioned terms
                    &amp; conditions shall be binding on both the Company and
                    the Client and shall become the only basis of relations
                    between the parties and all previous communication in
                    whatsoever form or mode whether oral or otherwise, with
                    respect to any terms &amp; conditions of the tour and
                    services shall stand cancelled / revoked / terminated.
                </p>
                <br />
                <h5>Declaration by the Client:</h5>
                <p>
                    I /We have read and accepted the above-mentioned terms &amp;
                    conditions on behalf of the person(s) whose name appears in
                    Booking Form and I am /we are aware that I / we shall be
                    abide by the same. I /We have also read the brochure / tour
                    itinerary and notes and I accept the same. I /We have been
                    given the copies of all the above-mentioned documents.
                </p>
            </div>
        </SimplePage>
    )
}

export default TermsAndCondition
